import '../css/components.css'
import noticeComponent from "../../components/notice/notice";
document.addEventListener('DOMContentLoaded', function() {
	noticeComponent();
});

